import React from 'react';

const PartnersSection = ({ partners, loading, onEdit, onDelete, onCreate }) => {
  return (
    <div className="card bg-dark border-0 shadow-lg rounded-5 overflow-hidden border-top border-5 border-primary">
      <div className="card-header bg-black bg-opacity-25 border-0 p-3 p-md-4 d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
        <h5 className="mb-0 fw-black text-uppercase">Réseau Partenaires ({partners.length})</h5>
        <button onClick={onCreate} className="btn btn-primary rounded-pill fw-black text-uppercase px-4 btn-sm shadow-sm w-100 w-md-auto">
          <i className="bi bi-plus-lg me-2"></i>Nouveau Partenaire
        </button>
      </div>
      <div className="card-body p-0">
        {loading ? (
          <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
        ) : (
          <div className="table-responsive" style={{ minWidth: '100%' }}>
            <table className="table table-dark table-hover mb-0 align-middle">
              <thead className="bg-secondary bg-opacity-10">
                <tr className="text-secondary fw-black text-uppercase small" style={{ fontSize: '10px' }}>
                  <th className="px-4 py-3" style={{ minWidth: '200px' }}>Logo & Nom</th>
                  <th className="px-4 py-3">Catégorie</th>
                  <th className="px-4 py-3 text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {partners.map((p) => (
                  <tr key={p.id} className="border-bottom border-secondary border-opacity-10">
                    <td className="px-4 py-3">
                      <div className="d-flex align-items-center">
                        <div className="bg-black rounded-3 me-3 d-flex align-items-center justify-content-center overflow-hidden border border-secondary border-opacity-25 flex-shrink-0" style={{ width: '45px', height: '45px' }}>
                          {p.logo_url && <img src={p.logo_url.startsWith('http') ? p.logo_url : `http://localhost:5000${p.logo_url}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />}
                        </div>
                        <div className="text-white fw-bold text-truncate" style={{ maxWidth: '150px' }}>{p.nom}</div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 fw-bold text-uppercase" style={{ fontSize: '10px' }}>
                        {p.categorie || "Général"}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-end">
                      <div className="d-flex justify-content-end gap-2">
                        <button className="btn btn-outline-warning btn-sm rounded-circle" onClick={() => onEdit(p)}><i className="bi bi-pencil"></i></button>
                        <button className="btn btn-outline-danger btn-sm rounded-circle" onClick={() => onDelete(p.id)}><i className="bi bi-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnersSection;